// Mesas sin nadie. En el lienzo son solo la silueta del tablero (visual.md §2.E: el «hueco libre» de la pantalla de
// inicio, casi invisible). Fuera de «Ordenar», solo la primera libre de cada sala es un botón: su + de contratar ahí, que
// sale al pasar el ratón (con el dedo, siempre). En «Ordenar», cada vacía se marca con contorno discontinuo (se puede
// soltar a alguien ahí). Las mesas son automáticas desde el 04-11: ya no se ponen ni se quitan a mano (Pau lo pidió el
// 09-10 y aprobó retirarlo el 04-11: dejaba mesas vacías congeladas).
import { Plus } from 'lucide-react';
import { memo } from 'react';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { PUESTO, type MesaMundo } from './generar';
import { estiloDe } from './geometria';
import { MarcaDestino } from './MarcaDestino';

const MAS = 'absolute left-1/2 flex h-8 w-8 -translate-x-1/2 items-center justify-center rounded-full bg-oficina-control text-oficina-texto2';

/** La primera libre de la sala, fuera de «Ordenar». */
export const MesaLibre = memo(function MesaLibre({ me, z, sala, destino, alContratar }: { me: MesaMundo; z: number; sala: string; destino: boolean; alContratar: (salaId?: string) => void }) {
  const texto = t('oficinaV2.escena.mesaLibre', { sala });
  return (
    <button
      type="button"
      onClick={() => alContratar(me.projectId)}
      aria-label={texto}
      title={texto}
      className="group absolute rounded-o-m outline-none focus-visible:ring-2 focus-visible:ring-oficina-enlace"
      style={estiloDe(me.rect, z)}
    >
      {/* Pau, 09-10 («menos +»): con el dedo, a la vista (en el iPad no hay «pasar el ratón»); con ratón, sale al pasar
          por la mesa o con el foco. */}
      <span
        className={cn(MAS, 'transition-opacity duration-150 ease-o-apple [@media(hover:hover)_and_(pointer:fine)]:opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100')}
        style={{ top: PUESTO.cabeza * z }}
      >
        <Plus className="h-4 w-4" aria-hidden />
      </span>
      {destino ? <MarcaDestino ocupada={false} /> : null}
    </button>
  );
});

/** Una mesa vacía en «Ordenar»: contorno discontinuo y el + de contratar si es la primera libre. */
export const MesaVacia = memo(function MesaVacia({ me, z, sala, destino, alContratar }: { me: MesaMundo; z: number; sala: string; destino: boolean; alContratar: (salaId?: string) => void }) {
  const contratar = t('oficinaV2.escena.mesaLibre', { sala });
  return (
    <div className="absolute rounded-o-m border border-dashed border-oficina-linea" style={estiloDe(me.rect, z)}>
      {me.libre ? (
        <button
          type="button"
          onClick={() => alContratar(me.projectId)}
          aria-label={contratar}
          title={contratar}
          className={cn(MAS, 'outline-none transition-colors duration-150 ease-o-apple hover:bg-oficina-pulsado hover:text-oficina-texto focus-visible:ring-2 focus-visible:ring-oficina-enlace')}
          style={{ top: PUESTO.cabeza * z }}
        >
          <Plus className="h-4 w-4" aria-hidden />
        </button>
      ) : null}
      {destino ? <MarcaDestino ocupada={false} /> : null}
    </div>
  );
});
